import { Component, OnInit ,Inject} from '@angular/core';
import {MatDialogRef,MAT_DIALOG_DATA} from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { $DBManagerService } from '../../DB/DBManager.service';
import { Constants } from '../../../_utils/Constants';
//import {PrincipalHeaderRegistrationComponent, DialogData} from '../../../_root/Trai_module/_pages/principal-header-registration/principal-header-registration.component';
import { EntitySummaryComponent,DialogData } from '../../../_root/Trai_module/_pages/entity-summary/entity-summary.component';
export interface DialogData {
  
  setValue: string,
  setRole: string
}

// set values to the role dropdown
export interface RoleArray
{
  
  value: string
}

 export interface status {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-my-dialog',
  templateUrl: './my-dialog.component.html'
  
})
export class MyDialogComponent implements OnInit {

  changeReason: any;
  changeStatus: any;
  rootHeaderValue: any;
  roleList :RoleArray[]=[
    { value: 'Application Adminstrator'},
    { value: 'Network Adminstrator'},
    { value: 'Operational User'}
  ]
 status: status[] = [
    { value: 'true', viewValue: 'BlackList' },
    { value: 'false', viewValue: 'Activate' }
  ];

  roleListArray=[]
  constructor(
    public dialogRef1: MatDialogRef<EntitySummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,private db: $DBManagerService)
     { }


  dialogForm: FormGroup;

  submitted: boolean = false;
  RoleIsPE: boolean = false;
  RoleIsRjio: boolean = false;
  newRootHeader: string;
  entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE)

  get f() { return this.dialogForm.controls; };

  ngOnInit() {
    this.dialogForm = this.fb.group({
      newRH : ['',[Validators.minLength(3)]],
      changeStatus:[''],
      reasonDeactivate:[''],
      previousRole:[this.data.setRole],
      changeRole:['']


  });

//   this.roleList = this.roleList.filter(function(val,i){
//     return val.key !== this.entityRole;
//   });
//  console.log("the role list in dialog",this.roleList)
this.roleListArray=this.roleList.filter(a=>a.value !== this.data.setRole)

// console.log("roleList array values",this.roleListArray)

  if(this.data.setValue == 'blacklist')
		  {
        this.dialogForm.controls['changeStatus'].enable();
        this.dialogForm.controls['reasonDeactivate'].enable();
        this.dialogForm.controls['changeStatus'].setValidators([Validators.required]);
        this.dialogForm.controls['reasonDeactivate'].setValidators([Validators.required]);
		  }
		  else
		  {
		  this.dialogForm.controls['changeRole'].enable();
      this.dialogForm.controls['changeRole'].setValidators([Validators.required]);
		}

  }

  onSubmit() {
    this.submitted = true;
   if(this.data.setValue == 'updaterole' && this.dialogForm.valid)
   {
   console.log("update role dialog",this.dialogForm.get('changeRole').value)
    this.dialogRef1.close(this.dialogForm.get('changeRole').value);
   }
   else if(this.entityClass == 'Tata Employee' && this.dialogForm.valid)
   {
   // console.log("This is the reason for changing",this.changeReason)
    var data1={
   
     "deactvStatus":this.changeStatus,
     "deactvReason":this.changeReason
   } 
  // console.log(data);
    this.dialogRef1.close(data1);
   }
    
  }

  onNoClick(): void {
    this.dialogRef1.close();
  }
/* 
  save() {

    this.dialogRef.close(this.newRootHeader);

  } */

}
